module.exports = __webpack_public_path__ + "img/menu_frame.5c65f59f.jpg";